export class UserWorkspaceNotificationSettings {
    constructor(model) {
        this.docsComments = model.DesignDocumentComment;
        this.projectChatMention = model.ChatMention;
        this.projectDocumentComments = model.ProjectDocumentComment;
        this.projectInvitation = model.ProjectInvitation;
    }
    toRemote() {
        return {
            DesignDocumentComment: this.docsComments,
            ChatMention: this.projectChatMention,
            ProjectDocumentComment: this.projectDocumentComments,
            ProjectInvitation: this.projectInvitation,
            /** @deprecated required for backward compatibility */
            liveblocksNotificationSettings: {
                sendCommentNotificationEmails: this.docsComments.email,
            },
        };
    }
}
